import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import StateStores from './StateStores';
import { ToastContainer } from 'react-toastify';

const root = ReactDOM.createRoot(document.getElementById('root'));
// "start": "set PORT=5001 && react-scripts start"

root.render(
  <StateStores>
    <React.StrictMode>
      <App/>
      <ToastContainer/>
    </React.StrictMode>
  </StateStores>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
